module.exports = __webpack_public_path__ + "static/media/md-egg.d883660a.svg";